<template>
  <BasePage :active="config.active">
    <div class="text-center mt-5" v-if="!success">
      <h4 class="primary--text font-weight-bold">FAÇA SEU CADASTRO</h4>
    </div>

    <v-form>
      <v-container>
        <v-alert v-if="success" type="success" class="mb-3" :icon="false" outlined>
          <p v-text="config.configs.message_success_registration" />

          <template v-if="qrcode && config.configs.show_qrcode">
            <qrcode-vue class="text-center" :value="qrcode" :size="150" level="H" />
          </template>

          <template v-if="qrcode && config.configs.show_barcode">
            <vue-barcode class="text-center mt-4" :value="qrcode"/>
          </template>
        </v-alert>

        <v-row v-else>
          <v-col v-for="field in fields" cols="12" md="4" :key="field.name">
            <v-text-field
                v-if="['text', 'number'].includes(field.type) && field.mask"
                :label="field.text"
                v-model="form[field.name]"
                :placeholder="field.placeholder"
                :inputmode="field.type === 'number' ? 'numeric' : ''"
                v-mask="field.mask"
                @input="clearErrors(field.name)"
                :error-messages="errors[field.name]"
            >
            </v-text-field>
            <v-text-field
                v-else-if="['text', 'number'].includes(field.type)"
                :label="field.text"
                v-model="form[field.name]"
                :placeholder="field.placeholder"
                :inputmode="field.type === 'number' ? 'numeric' : ''"
                @input="clearErrors(field.name)"
                :error-messages="errors[field.name]"
            >
            </v-text-field>
            <v-autocomplete
                v-if="field.type === 'options'"
                :label="field.text"
                :items="field.options"
                item-value="value"
                item-text="name"
                v-model="form[field.name]"
                @input="clearErrors(field.name)"
                :error-messages="errors[field.name]"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>

      <div class="text-center mt-3" v-if="!success">
        <v-btn
            elevation="5" class="primary"
            :loading="loading"
            :disabled="loading"
            @click="recaptcha">
          CADASTRAR
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon>$cached</v-icon>
            </span>
          </template>
        </v-btn>
      </div>
    </v-form>
  </BasePage>
</template>

<script>
import BasePage from "./structure/BasePage";
import swipeModal from '@takuma-ru/vue-swipe-modal';
import EasyCamera from 'easy-vue-camera';
import CpCamera from '../common/CpCamera';
import _ from "lodash"
import { mask } from "vue-the-mask"
import { useReCaptcha } from "vue-recaptcha-v3";

import QrcodeVue from 'qrcode.vue'
import axios from 'axios';
import VueBarcode from 'vue-barcode';

export default {
  name: "Registration",
  directives: { mask },

  components: {
    BasePage,
    swipeModal,
    EasyCamera,
    CpCamera,
    QrcodeVue,
    VueBarcode
  },
  data: _ => ({
    form: {},
    fields: [],
    errors: [],
    success: false,
    loading: false,
    qrcode: null,
    config: {
      active: true
    }
  }),
  mounted() {
    this.getData('fields').forEach((field) => {
      this.form[`${field.name}`] = null
    })

    this.fields = this.getData('fields')
    this.config = _config.functionalities.registration
  },

  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')

      if (token) {
        this.submit()
      }
    },
    inputed(data) {
      let formKey = Object.keys(data)[0];
      this.form[Object.keys(data)[0]] = data[formKey]
    },

    submit() {
      this.loading = true

      axios.post(this.route('smartmenu.registration-store', this.getData('hash')), this.form).then(response => {
        if (response.data.cpf && (this.config.configs.show_qrcode || this.config.configs.show_barcode)) {
          this.qrcode = response.data.cpf
        }
        this.success = true
        this.clearForm()
      }).catch((error) => {
        this.errors = error.response.data
        this.loading = false
      })
    },

    clearForm() {
      Object.keys(this.form).forEach(key => this.form[key] = null)
      this.loading = false
    },

    clearErrors(name) {
      this.errors[name] = null
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>